import { useCustomProperties } from '@networkteam/giraffe';

const PreviewIndicator = () => {
  const customProperties = useCustomProperties();

  if (customProperties?.isPreview === '1') {
    return (
      <div className="border-1 pointer-events-none fixed right-4 top-4 z-50 select-none rounded-sm border-orange-200 bg-orange-100 px-4 py-2 text-center font-sans text-sm font-bold text-orange-600">
        Vorschau
      </div>
    );
  }

  return;
};

export default PreviewIndicator;
